import "./Impact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OurHeartForChange from "./sections/OurHeartForChange";
import InvestInOurFuture from "./sections/InvestInOurFuture";
import OurClinicalJourney from "./sections/OurClinicalJourney";
import ExperienceInquiry from "./sections/ExperienceInquiry";
import MidnightRunnersCollection from "@/reusable_sections/Footer";
export default function ImpactPage() {
  return <div>
      <MainNavigation />
      <OurHeartForChange />
      <InvestInOurFuture />
      <OurClinicalJourney />
      <ExperienceInquiry />
      <MidnightRunnersCollection />
    </div>;
}